import { Reducer } from "redux";
import { LocalizationUtils } from "component-library";

import { ActionType } from "store/types";

import { FacetActions, FacetStoreKey, IFacetState } from "./facet.types";

export const initialState: IFacetState = {
  [FacetStoreKey.ProductionType]: undefined,
  [FacetStoreKey.ContractType]: undefined,
  [FacetStoreKey.Gender]: undefined,
  [FacetStoreKey.Appearance]: undefined,
  [FacetStoreKey.Disability]: undefined,
  [FacetStoreKey.ComplaintCategory]: undefined,
  [FacetStoreKey.EthnicBackground]: undefined,
  [FacetStoreKey.HeritageAndEthnicity]: undefined,
  locale: LocalizationUtils.getUserLocalizationPreference().locale,
};

const reducer: Reducer<IFacetState, FacetActions> = (
  state = initialState,
  action
): IFacetState => {
  switch (action.type) {
    case ActionType.SetCategory:
      return {
        ...state,
        [action.payload.key]: action.payload.data,
        locale: action.payload.locale,
      };
    case ActionType.SetCategories:
      return {
        ...state,
        ...action.payload.data,
        locale: action.payload.locale,
      };
    default:
      return state;
  }
};

export default reducer;
